import React from 'react'
import PropTypes from 'prop-types'

import { Loader } from 'semantic-ui-react'

const LoaderHOC = message => WrappedComponent => {
  const LoaderComponent = props => {
    const { loaderPending } = props

    if (loaderPending) {
      return <Loader content={message} size="massive" active />
    } else {
      return <WrappedComponent {...props} />
    }
  }

  LoaderComponent.propTypes = {
    loaderPending: PropTypes.bool.isRequired,
  }

  return LoaderComponent
}

LoaderHOC.propTypes = {
  message: PropTypes.string.isRequired,
}

export default LoaderHOC
